export const HTTP = "http";
export const HIDE_LAUNCH_LOADING = "hide_loading";
export const LAUNCH_PARAMS = "launch_params";
export const IAP_PRODUCT = "iap_product";
export const IAP_PURCHASE = "iap_purchase";
export const OPEN_BROWSER = "open_safari";
export const CLOSE_BROWSER = "close_safari";
export const REGISTER_UMENG_PUSH = "register_push";
export const CONFIG_UMENG_PUSH = "set_alias";

// export const HIDE_KEYBOARD = "hide_keyboard";
